import type { ApplicationInsights, IExtendedTelemetryItem } from "@microsoft/1ds-analytics-js";

/**
 * This has to be in a seperate export so we can properly spy on it in tests.
 * Do not add any more logic here.
 */
export function sendEventTo1DS(tenant: ApplicationInsights, item: IExtendedTelemetryItem): void {
    tenant.track(item);
}
